import { Table } from 'antd'
import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { BitazzaText, LeaderBoardLayout } from '../../../../components'
import { appCallbackHandler } from '../../../../util/AppCallbackHandler'
import Styles from './PrizePoolTable.module.scss'

export const PrizePoolTable: FC<unknown> = () => {
    const { t } = useTranslation()
    const dataSource = [
        {
            key: '1',
            rank: '1',
            prizePool: '20%',
            BTZAmountAwarded: '20,000',
            FDSAmountAwarded: '300',
        },
        {
            key: '2',
            rank: '2',
            prizePool: '10%',
            BTZAmountAwarded: '10,000',
            FDSAmountAwarded: '150',
        },

        {
            key: '3',
            rank: '3',
            prizePool: '5%',
            BTZAmountAwarded: '5,000',
            FDSAmountAwarded: '75',
        },
        {
            key: '4',
            rank: '4',
            prizePool: '4%',
            BTZAmountAwarded: '4,000',
            FDSAmountAwarded: '60',
        },
        {
            key: '5',
            rank: '5',
            prizePool: '3%',
            BTZAmountAwarded: '3,000',
            FDSAmountAwarded: '45',
        },
        {
            key: '6',
            rank: '6-10',
            prizePool: '2%',
            BTZAmountAwarded: '2,000',
            FDSAmountAwarded: '30',
        },
        {
            key: '7',
            rank: '11-25',
            prizePool: '1.20%',
            BTZAmountAwarded: '1,200',
            FDSAmountAwarded: '18',
        },
        {
            key: '8',
            rank: '26-50',
            prizePool: '0.60%',
            BTZAmountAwarded: '600',
            FDSAmountAwarded: '9',
        },
        {
            key: '9',
            rank: '51-100',
            prizePool: '0.30%',
            BTZAmountAwarded: '300',
            FDSAmountAwarded: '5',
        },
    ]

    const columns = [
        {
            title: t('txt_rank'),
            dataIndex: 'rank',
            key: 'rank',
            width: '10%',
            className: 'columnRank',
            render(text: string) {
                return (
                    <BitazzaText
                        content={text}
                        color="#fff"
                        format="t18"
                        noWrap
                    />
                )
            },
        },
        {
            title: t('txt_prize_allocation'),
            dataIndex: 'prizePool',
            key: 'prizePool',
            width: '30%',
            className: 'columnPrizePool',
            render(text: string) {
                return <BitazzaText content={text} color="#fff" format="t18" />
            },
        },
        // {
        //     title: t('txt_btz_awarded'),
        //     dataIndex: 'BTZAmountAwarded',
        //     key: 'BTZAmountAwarded',
        //     width: '30%',
        //     className: 'columnBtzAmount',
        //     render(text: string) {
        //         return (
        //             <BitazzaText content={text} color="#F1D87E" format="t18" />
        //         )
        //     },
        // },
        {
            title: t('txt_usdt_awarded'),
            dataIndex: 'FDSAmountAwarded',
            key: 'FDSAmountAwarded',
            width: '30%',
            className: 'columnUSDFAwarded',
            render(text: string) {
                return (
                    <BitazzaText content={text} color="#F1D87E" format="t18" />
                )
            },
        },
    ]
    useEffect(() => {
        appCallbackHandler('setToolbarHeaderUI', 'Prize Pool')
    }, [])

    return (
        <LeaderBoardLayout headerText="Prize Pool" isSeasonHeaderHidden>
            <div className={Styles.container}>
                <div className={Styles.header}>
                    <BitazzaText
                        content={t('txt_prize_pool')}
                        color="#fff"
                        format="t20"
                        letterSpacing={2}
                        bold
                    />
                </div>

                <div className={Styles.table}>
                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                    />
                </div>
            </div>
        </LeaderBoardLayout>
    )
}
